import { makeHook } from "../../../utils/makeSingleArgHook";
import getAssignees from "../../requests/persons/getAssignees";
import { assigneesUrl } from "../../requests/urls";
/**
 * @deprecated use v2 equivalent instead
 */
export const assigneesKeyMaker = (queryParams) => {
    if (!queryParams) {
        return [assigneesUrl("v1")];
    }
    return [assigneesUrl("v1"), JSON.stringify(queryParams)];
};
/**
 * @deprecated use v2 equivalent instead
 */
const useGetAssignees = makeHook(async (queryParams, auth) => getAssignees(auth, queryParams), (queryParams) => assigneesKeyMaker(queryParams));
export default useGetAssignees;
//# sourceMappingURL=useGetAssignees.js.map